import React, { useState, useRef, useEffect } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FiEdit2 } from "react-icons/fi";
import { FiXCircle } from "react-icons/fi";
import { FiBookOpen } from "react-icons/fi";

const Dropdown = ({ onAction, className, details, children }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [editMode, setEditMode] = useState(false)
    const toggleDropdown = (e) => {
        e.preventDefault()
        setShowDropdown(!showDropdown);
    };
    const handleAction = (mode) => {
        onAction(mode, details)
        setShowDropdown(!showDropdown);
    }
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        if (localStorage.getItem('patientEditMode') === 'true') {
            setEditMode(true)
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={`td_btn dropdown-container ${className} right-[13px] dot`}  >
            {/* To apply inline style : style={{ right: '13px' }} */}
            <button onClick={toggleDropdown} className="dot-button">
                <BsThreeDotsVertical />
            </button>
            {showDropdown && (
                <div
                    ref={dropdownRef}
                    className="dropdown-content show-dropdown left-[7em] bottom-[-5em]"
                >
                    <button onClick={() => handleAction('view')}>
                        <span> <FiBookOpen className="text-green-800 font-bold" /> </span> View details
                    </button>
                    <button onClick={() => handleAction('edit')}>

                        <span> <FiEdit2 className="text-green-800" /> </span> Edit details
                    </button>
                    <button onClick={() => handleAction('delete')}>
                        <span>
                            <FiXCircle className="text-red-800" />
                        </span>
                        Delete
                    </button>
                    {children}
                </div>
            )}
        </div>
    );
}

export default Dropdown;